// src/utils/dataStore.js
const dataStore = {
  apparelStyles: {},
  printStyles: {},
  colors: [],
  shapeSizes: ["round", "square", "heart"], // sabit kalabilir, veya API'den geliyorsa onu da ekleyebilirsiniz
};

export default dataStore;
